import { TD, Table, TableRow } from "@/components/DesignLibrary/Table";
import { FC, useCallback } from "react";
import formatAmountWithCurrency from '@format/priceWithCurrency';
import { Currency } from '@/typings/api-models';
import { MeansTestAiResponse, MeansTestResponse } from '@/tsClient/servers/noodleDocuments/document-api-models';

import s from './DocumentRequestUserDetail.module.scss';

const meansTestDataKeys = [
  {
    key: 'grossMonthlyIncome',
    label: "2. Gross Monthly Income",
  },
  {
    key: 'alimonyAndMaintenancePayments',
    label: "3. Alimony And Maintenance Payments",
  },
  {
    key: 'rentalPropertyIncome',
    label: "6. Net income from rental and other real property",
  },
  {
    key: 'interestDividendsAndRoyalties',
    label: "7. Interest, Dividends And Royalties",
  },
  {
    key: 'unemploymentCompensation',
    label: "8. Unemployment compensation",
  },
  {
    key: 'pensionOrRetirementIncome',
    label: "9. Pension or retirement income",
  },
  {
    key: 'otherHouseholdIncome',
    label: "10. Income from all other sources not listed above",
  },
];

const CalculatorTable: FC<{ data: MeansTestResponse }> = ({ data }) => {
  const normalizeValue = useCallback(
    (value: string | number | null | undefined): string => {
      if(value === null || value === undefined) return "--";
      if(typeof value === 'number') return formatAmountWithCurrency(value, Currency.Usd);
      if(typeof value === 'string') return Number.isNaN(Number(value)) ? "--" : formatAmountWithCurrency(Number(value), Currency.Usd);
      return "--";
    },
    [],
  );
  return (
    <div className={s.calculatorTable}>
      <Table>
        {meansTestDataKeys.map(({ key, label }) => (
          <TableRow key={key}>
            <TD compact label={label} />
            <TD compact label={normalizeValue(data.data[key as keyof MeansTestAiResponse])} />
          </TableRow>
        ))}
      </Table>
    </div>
  );
};

export default CalculatorTable;
